import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { useSesion } from './estado/SesionContext';
import { Cabecera } from './components/Cabecera';
import { AvisoFase0 } from './components/AvisoFase0';
import { Login } from './pages/Login';
import { Home } from './pages/Home';
import { Curso } from './pages/Curso';
import { Quiz } from './pages/Quiz';
import { Recompensas } from './pages/Recompensas';
import { Modulos } from './pages/Modulos';
import { Quizzes } from './pages/Quizzes';

function Privado() {
  const { perfil, cargando } = useSesion();

  if (cargando) {
    return <p className="p-10 text-center text-gris">Cargando…</p>;
  }
  if (!perfil) {
    return <Navigate to="/entrar" replace />;
  }

  return (
    <>
      <Cabecera />
      <AvisoFase0 />
      {/* pb-24 en celular: la barra inferior fija taparía el final del contenido. */}
      <main className="mx-auto max-w-5xl px-4 pb-24 pt-4 md:pb-12">
        <Outlet />
      </main>
    </>
  );
}

function Publico() {
  const { perfil, cargando } = useSesion();
  if (cargando) return <p className="p-10 text-center text-gris">Cargando…</p>;
  // Quien ya tiene sesión no debería ver el formulario de ingreso.
  if (perfil) return <Navigate to="/" replace />;
  return <Login />;
}

export const router = createBrowserRouter([
  { path: '/entrar', element: <Publico /> },
  {
    path: '/',
    element: <Privado />,
    children: [
      { index: true, element: <Home /> },
      { path: 'modulos', element: <Modulos /> },
      { path: 'quizzes', element: <Quizzes /> },
      { path: 'curso/:cursoId', element: <Curso /> },
      { path: 'curso/:cursoId/quiz', element: <Quiz /> },
      { path: 'recompensas', element: <Recompensas /> },
      // Una ruta inventada devuelve al inicio en vez de mostrar una pantalla en blanco.
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
